export type Locale = (typeof locales)[number];

export const locales = ['ru', 'kk', 'en'] as const;
export const defaultLocale: Locale = 'ru';
